<h1 mat-dialog-title>{{discriminator.discriminatorName}}</h1>
<div mat-dialog-content>
  <div class="modal-body text-center">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()" [appUppercaseForm]="this.setUppercaseText">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <mat-form-field appearance="outline">
            <mat-label>Valor</mat-label>
            <input [mask]="masks.oneDigit" type="text" matInput formControlName="value">
          </mat-form-field>
        </div>
      </div>
      @if (data.classificationData.priorityAutistic && !data.discriminatorsValues[this.discriminatorType]) {
        <div
          class="row">
          <div class="col-12">
            <mat-slide-toggle class="priorityAutistic" (change)="changePriorityAutistic($event)"
              formControlName="priorityAutistic">
              Não é possível aferir
            </mat-slide-toggle>
          </div>
          @if (autisticChecked) {
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>Motivo</mat-label>
                <textarea type="text" matInput formControlName="discriminatorSelectionMotive"></textarea>
              </mat-form-field>
            </div>
          }
        </div>
      }
      <div class="footer-panel-modal-list">
        <div class="row">
          <div class="col-12">
            <button type="submit" mat-flat-button color="primary" class="btn-block">Concluir</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>